import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const subTextColor = useColorModeValue('gray.600', 'gray.400');
  const inputBgColor = useColorModeValue('white', 'whiteAlpha.50');
  const hoverBgColor = useColorModeValue('gray.50', 'whiteAlpha.50');
  const selectedBgColor = useColorModeValue('blue.50', 'whiteAlpha.50');

  return {
    backgroundCardColor,
    textColor,
    borderColor,
    subTextColor,
    inputBgColor,
    hoverBgColor,
    selectedBgColor,
  };
};
